import { render, staticRenderFns } from "./CopiarDados.vue?vue&type=template&id=6e859cb8&scoped=true&"
import script from "./CopiarDados.vue?vue&type=script&lang=js&"
export * from "./CopiarDados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e859cb8",
  null
  
)

export default component.exports